import { Box, Typography, Button } from "@mui/material";

const SodexoPayment = ({
  route,
  sodexo,
  defaultPgName,
  SetpaymentGatewayId,
  setSodexoUnlinkModal,
  SodexoLink,
  LinkSodexo,
  plxlogo,
}) => {
  // 🔹 extract base route (handles: taghistory/0035968753)
  const baseRoute = route?.replace(/^\/|\/$/g, "").split("/")[0];

  // 🔹 hide on these routes
  const shouldHide = ["dphistory", "taghistory"].includes(baseRoute);

  if (shouldHide) return null;

  return (
    <>
      {sodexo?.active ? (
        <Box
          sx={{
            mb: 1,
            p: 1,
            borderRadius: "15px",
            boxShadow:
              defaultPgName === "SODEXO"
                ? "0px 4px 10.4px 1px rgba(0, 177, 119, 0.23)"
                : "none",
            border:
              defaultPgName === "SODEXO"
                ? "1px solid rgba(0, 177, 119, 0.5)"
                : "none",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <Box
              sx={{ display: "flex", alignItems: "center", width: "81%", cursor: "pointer" }}
              onClick={(e) =>
                SetpaymentGatewayId(e, sodexo?.pgId, sodexo?.pgName, "SODEXO")
              }
            >
              <img
                src={plxlogo}
                alt="Pluxee"
                style={{ width: "37px", objectFit: "contain" }}
              />
              <Box sx={{ ml: 1 }}>
                <Typography fontSize={16} fontWeight={500} color="#333F4E">
                  Pluxee
                </Typography>
                <Typography fontSize={13} color="#718198">
                  Pay with Pluxee
                </Typography>
              </Box>
            </Box>

            <Button
              sx={{ color: "#00B177" }}
              onClick={() => setSodexoUnlinkModal(true)}
            >
              UNLINK
            </Button>
          </Box>
        </Box>
      ) : (
        <Box
          sx={{ mb: 1, p: 1, borderRadius: "15px", cursor: "pointer" }}
          onClick={SodexoLink}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <img
                src={plxlogo}
                alt="Pluxee"
                style={{ width: "37px", objectFit: "contain" }}
              />
              <Box sx={{ ml: 1 }}>
                <Typography fontSize={16} fontWeight={500} color="#333F4E">
                  Pluxee
                </Typography>
                <Typography fontSize={13} color="#718198">
                  Pay with Pluxee
                </Typography>
              </Box>
            </Box>

            <Button sx={{ color: "#00B177" }} onClick={LinkSodexo}>
              Link
            </Button>
          </Box>
        </Box>
      )}
    </>
  );
};

export default SodexoPayment;
